import * as React from "react";
import { SvgIcon } from "@origin-digital/ods-icons";
import {
  ConnectionTypeEnum,
  RequestTypeEnum,
  ServiceTypeEnum,
  State,
} from "../Premises/types";
import { Box } from "@origin-digital/ods-core";
import { RequestChannelEnum } from "../Changes/types";
import { RequestTypeIconWithHoverTip } from "../Changes/ChangesTable";
import { IconElectricityLocal } from "./IconElectricityLocal";
import {
  IconAddressNotFound,
  IconInternetLocal,
  IconPreInstall,
} from "./IconInternetLocal";

export const DBFormIcon = () => (
  <Box marginLeft="xxsmall">
    <SvgIcon color="neutral" titleAccess="DB form">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C4.135 2 1 5.135 1 9a6.99 6.99 0 0 0 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26A6.99 6.99 0 0 0 15 9c0-3.865-3.135-7-7-7Zm2 11.695.855-.595A5.003 5.003 0 0 0 13 9.005c0-2.755-2.245-5-5-5s-5 2.245-5 5c0 1.63.8 3.16 2.145 4.1L6 13.7V16h4v-2.305Z"
      />
      <path d="M5 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H5v1Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.53 8.92c.8-.72 1.2-1.67 1.2-2.85 0-1.227-.393-2.183-1.18-2.87-.787-.687-1.867-1.03-3.24-1.03h-2.4V10h2.37c1.367 0 2.45-.36 3.25-1.08Zm-1.22-4.59c.507.413.76.993.76 1.74 0 .753-.25 1.343-.75 1.77-.5.42-1.163.63-1.99.63h-.8V3.7h.82c.8 0 1.453.21 1.96.63Z"
      />
    </SvgIcon>
  </Box>
);

export const GasMeterIcon = ({
  titleAccess,
}: {
  titleAccess?: string | undefined;
}) => (
  <SvgIcon titleAccess={titleAccess}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4Zm2 14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10Zm-8.5-2.46C9.5 16.9 10.62 18 12 18s2.5-1.1 2.5-2.46c0-.925-.324-1.295-1.674-2.84-.241-.276-.515-.59-.826-.95-.299.346-.563.65-.797.917C9.815 14.255 9.5 14.616 9.5 15.54ZM8 8h8v2H8V8Z"
      fill="#505050"
    />
  </SvgIcon>
);

export const NaturalGasMeterIcon = ({
  titleAccess,
}: {
  titleAccess?: string | undefined;
}) => (
  <SvgIcon titleAccess={titleAccess}>
    <g clipPath="url(#meter_and_service_line_v3__a)">
      <path fill="#fff" d="M0 0h24v24H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3h-1V1h-2v2H8V1H6v2H5C2.79 3 1 4.79 1 7v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V7c0-2.21-1.79-4-4-4Zm2 14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10Zm-8.5-2.46C6.5 15.9 7.62 17 9 17s2.5-1.1 2.5-2.46c0-.925-.324-1.295-1.674-2.84-.241-.276-.515-.59-.826-.95-.299.346-.563.65-.797.917C6.815 13.255 6.5 13.616 6.5 14.54ZM5 7h8v2H5V7Z"
        fill="#505050"
      />
      <path d="M14 13h3v10h-3z" fill="#fff" />
      <path d="M20 18v3H8v-3z" fill="#fff" />
      <path
        d="M13.8 11.5c-.708 0-1.35.54-1.35 1.286s.642 1.285 1.35 1.285h.35v.601a3.996 3.996 0 0 0-2.316 1.093H8.7c-1.177 0-2.2.891-2.2 2.072v2.469c0 1.18 1.023 2.072 2.2 2.072h3.134A4.026 4.026 0 0 0 14.65 23.5h1.7a4.026 4.026 0 0 0 2.816-1.122H22.3c1.177 0 2.2-.892 2.2-2.072v-2.47c0-1.18-1.023-2.07-2.2-2.07h-3.134a3.996 3.996 0 0 0-2.316-1.094v-.6h.35c.708 0 1.35-.54 1.35-1.286 0-.747-.642-1.286-1.35-1.286h-3.4Zm6.45 6.837h1.55v1.469h-1.55v-1.47Zm-9.5 1.469H9.2v-1.47h1.55v1.47Zm2.7-1.52c0-.556.5-1.072 1.2-1.072h1.7c.7 0 1.2.516 1.2 1.072v1.571c0 .556-.5 1.072-1.2 1.072h-1.7c-.7 0-1.2-.516-1.2-1.072v-1.571Z"
        stroke="#fff"
        fill="#505050"
      />
    </g>
    <defs>
      <clipPath id="meter_and_service_line_v3__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const ServiceLineIcon = ({
  titleAccess,
}: {
  titleAccess?: string | undefined;
}) => (
  <SvgIcon titleAccess={titleAccess}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 5a1 1 0 0 0 0 2h2v2c-1.23 0-2.33.555-3.064 1.428H2a2 2 0 0 0-2 2v4.143a2 2 0 0 0 2 2h5.936A3.991 3.991 0 0 0 11 20h2a3.99 3.99 0 0 0 3.064-1.429H22a2 2 0 0 0 2-2v-4.143a2 2 0 0 0-2-2h-5.936A3.992 3.992 0 0 0 13 9V7h2a1 1 0 1 0 0-2H9Zm7.96 7.428c.026.187.04.378.04.572v3c0 .194-.014.385-.04.571H22v-4.143h-5.04Zm-9.92 4.143A4.034 4.034 0 0 1 7 16v-3c0-.194.014-.385.04-.572H2v4.143h5.04ZM9 13a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-3Z"
      fill="#505050"
    />
  </SvgIcon>
);

export const ConnectionTypeIcon = ({ type }: { type: string }) => {
  switch (type) {
    case ConnectionTypeEnum.PERMANENT:
    case ConnectionTypeEnum.TEMPORARY:
    case ConnectionTypeEnum.TEMPPERM:
      return <IconElectricityLocal color="neutral" />;
    case ConnectionTypeEnum.SERVICE_CONNECTION:
      return <ServiceLineIcon />;
    case ConnectionTypeEnum.METER_FIX:
      return <GasMeterIcon />;
    case ConnectionTypeEnum.SERVICE_CONNECTION_AND_METER_FIX:
      return <NaturalGasMeterIcon />;
    default:
      return null;
  }
};

export const ConnectionTypeIconWithHoverTip = ({
  type,
  state,
  requestChannel,
}: {
  type?: string;
  state: string;
  requestChannel?: string | null;
}) => {
  if (requestChannel === "NETWORK") {
    return <DBFormIcon />;
  }
  switch (type) {
    case undefined:
    case ConnectionTypeEnum.PERMANENT:
    case ConnectionTypeEnum.TEMPORARY:
    case ConnectionTypeEnum.TEMPPERM:
      return (
        <IconElectricityLocal
          titleAccess="Electricity request"
          color="neutral"
        />
      );
    case ConnectionTypeEnum.SERVICE_CONNECTION:
      switch (state) {
        case State.NSW:
          return <ServiceLineIcon titleAccess="Path valve request" />;
        default:
          return <ServiceLineIcon titleAccess="Gas line request" />;
      }
    case ConnectionTypeEnum.METER_FIX:
      switch (state) {
        case State.NSW:
          return <GasMeterIcon titleAccess="Meter kit request" />;
        default:
          return <GasMeterIcon titleAccess="Gas meter request" />;
      }
    case ConnectionTypeEnum.SERVICE_CONNECTION_AND_METER_FIX:
      switch (state) {
        case State.NSW:
          return (
            <NaturalGasMeterIcon titleAccess="Full gas connection request" />
          );
        default:
          return (
            <NaturalGasMeterIcon titleAccess="Gas line and meter request" />
          );
      }
    case ConnectionTypeEnum.CAN_RETAIL:
      return (
        <IconInternetLocal titleAccess="Internet request" color="neutral" />
      );
    case ConnectionTypeEnum.PRE_INSTALL_NBN:
      return (
        <IconPreInstall titleAccess="Pre-install NBN request" color="neutral" />
      );
    case ConnectionTypeEnum.ADDRESS_NOT_FOUND:
      return (
        <IconAddressNotFound
          titleAccess="Address not found request"
          color="neutral"
        />
      );
    default:
      return null;
  }
};

export const DraftConnectionTypeIconWithHoverTip = ({
  type,
  state,
  requestType,
  serviceType,
  channel,
}: {
  type?: string;
  state: string;
  requestType: RequestTypeEnum;
  serviceType: ServiceTypeEnum;
  channel: RequestChannelEnum | null;
}) => {
  //1. Change and remove supply icons
  if (
    [RequestTypeEnum.CHANGE_SUPPLY, RequestTypeEnum.REMOVE_SUPPLY].includes(
      requestType
    )
  ) {
    return (
      <RequestTypeIconWithHoverTip
        requestType={requestType}
        serviceType={serviceType}
        channel={channel}
      />
    );
  }
  //2. New connection icons
  //DB form icons
  if (channel === RequestChannelEnum.NETWORK) {
    return <DBFormIcon />;
  }
  //Other icons
  switch (type) {
    case undefined:
    case ConnectionTypeEnum.PERMANENT:
    case ConnectionTypeEnum.TEMPORARY:
    case ConnectionTypeEnum.TEMPPERM:
      return (
        <IconElectricityLocal
          titleAccess="Electricity request"
          color="neutral"
        />
      );
    case ConnectionTypeEnum.SERVICE_CONNECTION:
      switch (state) {
        case State.NSW:
          return <ServiceLineIcon titleAccess="Path valve request" />;
        default:
          return <ServiceLineIcon titleAccess="Gas line request" />;
      }
    case ConnectionTypeEnum.METER_FIX:
      switch (state) {
        case State.NSW:
          return <GasMeterIcon titleAccess="Meter kit request" />;
        default:
          return <GasMeterIcon titleAccess="Gas meter request" />;
      }
    case ConnectionTypeEnum.SERVICE_CONNECTION_AND_METER_FIX:
      switch (state) {
        case State.NSW:
          return (
            <NaturalGasMeterIcon titleAccess="Full gas connection request" />
          );
        default:
          return (
            <NaturalGasMeterIcon titleAccess="Gas line and meter request" />
          );
      }
    case ConnectionTypeEnum.CAN_RETAIL:
      return (
        <IconInternetLocal titleAccess="Internet request" color="neutral" />
      );
    case ConnectionTypeEnum.PRE_INSTALL_NBN:
      return (
        <IconPreInstall titleAccess="Pre-install NBN request" color="neutral" />
      );
    case ConnectionTypeEnum.ADDRESS_NOT_FOUND:
      return (
        <IconAddressNotFound
          titleAccess="Address not found request"
          color="neutral"
        />
      );
    default:
      return null;
  }
};

export { IconElectricityLocal };
